import { faEdit, faRedoAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useDispatch } from 'react-redux';
import { actions } from '../../../../../../../../../context';
import classNames from 'classnames';
import './styles.css';

const EditMappingButton = ({ code, mapping, isUpdating }) => {
    const dispatch = useDispatch();

    let buttonIcon = faRedoAlt;
    if (!isUpdating) {
        buttonIcon = faEdit;
    }

    const editMapping = () => {
        dispatch(actions.daylight.setActionTargetCode(code));
        dispatch(actions.daylight.setActionTargetMapping(mapping));
        dispatch(actions.daylight.setEditMappingModalOpen(true));
    };

    return (
        <FontAwesomeIcon
            className={classNames('mr-2 edit-mapping pop-hoverable', {
                rotating: isUpdating,
                'fa-disabled': isUpdating,
            })}
            onClick={editMapping}
            icon={buttonIcon}
            size="lg"
            title="Edit Mapping"
        />
    );
};

export default EditMappingButton;
